import { render, staticRenderFns } from "./tableTodayNew.vue?vue&type=template&id=3479d19e&scoped=true"
import script from "./tableTodayNew.vue?vue&type=script&lang=js"
export * from "./tableTodayNew.vue?vue&type=script&lang=js"
import style0 from "./tableTodayNew.vue?vue&type=style&index=0&id=3479d19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479d19e",
  null
  
)

export default component.exports